export default __webpack_public_path__ + "static/media/760.814d925f.png";